import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';

@Component({
  selector: 'app-forum-item',
  templateUrl: './forum-item.component.html',
  styleUrls: ['./forum-item.component.scss'],
  providers: [AngularFireDatabase, AngularFireAuth]
})
export class ForumItemComponent implements OnInit {

  @Input() item : any;
  @Input() id: string;
  showComments : boolean = false;
  user : any;
  profile : any = {
    avatarUrl: 'https://chispa-ruralchispa-rural.firebaseapp.com/assets/img/avatar.png',
  }
  constructor(private db: AngularFireDatabase, private afAuth: AngularFireAuth) {
  }

  ngOnInit() {
    this.afAuth.auth.onAuthStateChanged(user => {
      this.user = user;
    })

    const subscription = this.db.object(`profiles/${this.item.userId}`)
    .valueChanges().subscribe(snapshot => {
      subscription.unsubscribe();
      Object.assign(this.profile, snapshot);
    })
  }

  loadReplies() {
    if (!this.showComments) this.showComments = true;
  }

  getDate(date) {
    let formatDate = moment(date);
    moment.locale('es')
    return(formatDate.format('DD MMM YYYY'));
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum-item/forum-item.component.ts